import React from 'react';
import request from 'arcdynamic-request';
import {LENDERS} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import Input from "../Input-new/Input";

const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectLender extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            lender: {},
        };

        this.getSelectedOption = this.getSelectedOption.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.fetch(0);
    }

    fetch(offset) {
        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', LENDERS, {
                limit: {
                    count: limit,
                    offset: offset * limit,
                },
                column: [
                    'ARCIMEDES_ROW_ID',
                    'NAME',
                    'CONTACT_NAME',
                ],
                filter: [{
                    code: 'NAME',
                    text: '',
                    type: 'notNull',
                }, {
                    code: 'DELETED',
                    text: '',
                    type: 'null',
                }],
                filterType: 'and',
                order: [{
                    code: 'NAME',
                    type: 'asc',
                }],
            }],
        }).then(res => {
            this.setState(prevState => {
                const items = prevState.items.concat(res.data);
                return {
                    items,
                };
            });
            if (res.data.length >= limit) {
                this.fetch(++offset);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newLender !== nextProps.newLender) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newLender);
            this.setState({
                items,
                lender: nextProps.newLender,
            });
        }
    }

    getSelectedOption(option) {
        if (!Object.keys(this.state.lender).length)
            this.setState({lender: option});
    }

    handleChange(data, optionsType, value, valueKey, typeKey, option) {
        this.setState({lender: option});
        this.props.handleParentChange(data, optionsType, value, valueKey, typeKey);
    }

    render() {
        const { items, lender } = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            handleParentChange,
            isFilter,
            viewMode,
            addNewItem,
            deleted,
            isFromProperty,
            withContact,
            className,
            ...rest,
        } = this.props;

        return (
            <React.Fragment>
                <Dropdown theme={theme}
                          className={className}
                          optionsType='lender'
                          optionKey='ARCIMEDES_ROW_ID'
                          options={items}
                          value={value}
                          valueKey={valueKey}
                          label={label}
                          disabled={!items || disabled}
                          data={data}
                          isFilter={isFilter}
                          handleParentChange={this.handleChange}
                          withAddNew={withAddNew}
                          viewMode={viewMode}
                          deleted={deleted}
                          addNewItem={addNewItem}
                          isFromProperty={isFromProperty}
                          getSelectedOption={this.getSelectedOption}
                          {...rest}
                />
                {
                    withContact &&
                    <Input theme={theme}
                           className={className}
                           name='CONTACT_NAME'
                           value={lender && lender.CONTACT_NAME}
                           valueType="text"
                           label='Lender Contact'
                           disabled
                           viewMode={viewMode}
                           deleted={deleted}
                    />
                }
            </React.Fragment>
        )
    }
}

SelectLender.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    withContact: PropTypes.bool,
    className: PropTypes.string,
};

export default SelectLender;
